import localforage from 'localforage';
import { WebStorageService } from '@techniek-team/storage';

/**
 * @deprecated Package is moved to @techniek-team/storage this version will be removed in the next major version. v23
 */
export const Drivers = {
  //eslint-disable-next-line @typescript-eslint/naming-convention
  IndexedDB: localforage.INDEXEDDB,
  //eslint-disable-next-line @typescript-eslint/naming-convention
  LocalStorage: localforage.LOCALSTORAGE,
};

/**
 * @deprecated Package is moved to @techniek-team/storage this version will be removed in the next major version. v23
 */
export interface StorageConfig {
  name?: string;

  size?: number;

  tables?: string[];

  description?: string;

  driverOrder?: string[];

  dbKey?: string;
}

/**
 * @deprecated Package is moved to @techniek-team/storage this version will be removed in the next major version. v23
 */
export class StorageService extends WebStorageService {}
